import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import InterestEditor from './InterestEditor';

function EditInterest() {
	const { id } = useParams();
	const navigate = useNavigate();

	return (
		<EntityList>
			<Helmet>
				<title>Editar Interes</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Intereses', to: '/AdminScreen/interests' },
					{ label: 'Editar Interes' },
				]}
				title='Editar Interes'
				subtitle='Actualizá los datos principales del interés.'
			/>
			<InterestEditor
				mode='edit'
				interestId={id}
				onCancel={() => navigate(`/AdminScreen/interests/interest/${id}`)}
				onSaved={(savedInterestId) => navigate(`/AdminScreen/interests/interest/${savedInterestId || id}`)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditInterest;
